import { useAuth } from '../../context';
import { TeamMemberRole } from '../../utils/user-roles';

interface AuthorizationProps {
  allowedRoles: TeamMemberRole[];
  children: React.ReactNode;
}

export const Authorization = ({
  children,
  allowedRoles,
}: AuthorizationProps) => {
  const { roles, initialized, userIsLogged } = useAuth();

  if (initialized && !userIsLogged) return null;

  if (!roles?.some((userRole) => allowedRoles.includes(userRole))) return null;

  return <>{children}</>;
};
